import { useQuery } from "@tanstack/react-query";
import { apiCEP } from "../../api";

export interface IFetchCEP {
  cep: string;
  enable?: boolean;
}
const fetchAddressByCEP = async (cep: string) => {
  const response = await apiCEP.get(`/${cep}/json/`);
  const data = response.data;
  if (response.status === 200 && data.erro === "true") {
    throw new Error("CEP não encontrado");
  } else if (response.status === 200) {
    return {
      street: data.logradouro,
      neighborhood: data.bairro,
      city: data.localidade,
      state: data.uf,
      country: "BR",
    };
  }

  throw new Error("Erro ao buscar o CEP");
};

export const useAddressByCEP = ({ cep }: IFetchCEP) => {
  const formattedCep = cep?.replace(/\D/g, "");

  return useQuery({
    queryKey: ["address", cep],
    queryFn: () => fetchAddressByCEP(cep),
    enabled: formattedCep?.length === 8,
    staleTime: 1000 * 60 * 2,
    retry: false,
  });
};
